export interface StoreData {
  id: string;
  imageUrl: string;
  logoUrl: string;
  storeName: string;
  description: string;
  verified: boolean;
  urls: {
    label: string;
    url: string;
  }[];
}

export const storeData: StoreData[] = [
  {
    id: "store1",
    imageUrl: "/chawoo.png",
    logoUrl: "/chawoo.png",
    storeName: "CHAWOO PREMIUM",
    description: "퀄리티 높은 완성된 스크립트 및 플러그인 판매 및 배포",
    verified: true,
    urls: [
      { label: "판매 디스코드", url: "https://discord.gg/wYQKYMEx6A" },
      { label: "주문 디스코드", url: "https://discord.gg/Uv5PTD9erE" }
    ]
  },
  {
    id: "store2",
    imageUrl: "/chun2.png",
    logoUrl: "/chun.png",
    storeName: " KP CLOUD",
    description: "최저가 호스팅 게임 서버/디스코드 봇/웹 개발에 관심 있으신 개발자와 창작자 분들을 위한 최고의 서비스를 제공합니다! ",
    verified: true,
    urls: [
      { label: "디스코드", url: "https://discord.gg/N4CRDbwUgB" }
    ]
  },
  {
    id: "store3",
    imageUrl: "https://funpin.co.kr/pa.png",
    logoUrl: "https://funpin.co.kr/pa.png",
    storeName: "Funpin",
    description: " SOOP 별풍선, 팬더TV 하트, 플렉스TV 렉스, 연동티비, 팝콘TV, 아프리카TV 등 최저가, 24시간 신속하게 처리해드립니다.",
    verified: true,
    urls: [
      { label: "홈페이지", url: "https://funpin.co.kr/" }
    ]
  },
  {
    id: "store4",
    imageUrl: "https://meta-station.com/assets/meta-favicon.png",
    logoUrl: "https://meta-station.com/assets/meta-favicon.png",
    storeName: "메타스테이션",
    description: "21세기를 향한 메타프로젝트, 다양한 디지털 콘텐츠를 전시하는 메타스테이션",
    verified: true,
    urls: [
      { label: "홈페이지", url: "https://meta-station.com/" }
    ]
  }
]; 